import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NftContainer } from '../components';
import { getNftPaginate } from '../features/nft/nftSlice';
const Collection = () => {
  const dispatch = useDispatch();
  const { account, chainId } = useSelector((store) => store.user);

  useEffect(() => {
    dispatch(getNftPaginate());
  }, [account, chainId, dispatch]);

  return <NftContainer />;
};

export default Collection;
